<template>
  <div>
    <label>{{ label }}</label>
    <ul v-if="values">
      <li v-for="val in values" :key="val">
        <span>{{ val }}</span>
      </li>
    </ul>
    <span v-else>{{ value }}</span>
  </div>
</template>
<script setup lang="ts">
interface Props {
  label: string;
  value: string | { name: string }[];
}
const props = defineProps({
  label: null,
  value: null
});
const values = computed<string[]>(() => {
  if (Array.isArray(props.value)) {
    return props.value.map((v) => v.name);
  } else {
    return null;
  }
});
</script>
<style lang="scss" scoped>
div {
  display: flex;
  flex-direction: column;
  gap: var(--gap_xss);
}
label {
  @include font('n', '700', 'secondary');
}
</style>
